import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import ArticleList from '../articleList';
import createArticleEvents from '../../../utils/trackers/createArticleEvents';
import createArticleProps from '../../../utils/recommendations/createArticleProps';
import {
  createRecommendationClickTracker,
  trackRecommendationViews,
} from '../../../utils/trackers/trackRecommendations';
import hasRecommendations from '../../../utils/recommendations/hasRecommendations';
import { panelType } from '../../../../shared/constants';

const panelName = 'recommended-article';

const getData = ({ recommendations: { data } }) => data;

const mapStateToProps = createSelector([getData], (data) => {
  const articleProps = hasRecommendations(data)
    ? data.recommendations.map(createArticleProps) : [];

  const articles = articleProps.map((props, index) => {
    const {
      contentType, documentType, documentSubtype, pii, doi,
    } = props;

    return {
      ...props,
      key: props.doi,
      articlePreviewPanel: panelType.recommendationsArticlePreview,
      articlePreviewProps: { index },
      eventData: createArticleEvents(
        panelName, { contentType, documentType, documentSubtype }, { pii, doi },
      ),
      onComponentClick: createRecommendationClickTracker(panelName, props),
    };
  });

  return {
    articles,
    onRender: () => trackRecommendationViews(panelName, articles),
  };
});

export default connect(mapStateToProps)(ArticleList);
